export const palette_oracle_3951 = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Kaplama Yok",
        material: "01_default",
    },
    "#f44336" : {
        display: "Uzaysal Turuncu 3M 3080 Pro Serisi",
        name: "Uzaysal Turuncu",
        material: "01_default",
    },
}

export const palette_oracle_970_standard = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Kaplama Yok",
        material: "01_default",
    },
    "#eff1f0" : {
        display: "Kar Beyaz",
        name: "#010 White",
        material: "21_shiny_2r",
    },
    "#e5dcb7" : {
        display: "Ivory",
        name: "#809 Taxibeige",
        material: "21_shiny_2r",
    },
    "#d7c9ab" : {
        display: "Papirüs",
        name: "#816 Papyrus",
        material: "21_shiny_2r",
    },
    "#f6df21" : {
        display: "Krokus",
        name: "#201 Crocus yellow",
        material: "21_shiny_2r",
    },
    "#f1da00" : {
        display: "Kanarya",
        name: "#235 Canary yellow",
        material: "21_shiny_2r",
    },
    "#ffd000" : {
        display: "Neon",
        name: "#216 Traffic yellow",
        material: "21_shiny_2r",
    },
    "#ffd100" : {
        display: "Limon",
        name: "#022 Light yellow",
        material: "21_shiny_2r",
    },
    "#daa800" : {
        display: "Flaks",
        name: "#209 Maize yellow",
        material: "21_shiny_2r",
    },
    "#ffad00" : {
        display: "Altın",
        name: "#020 Golden yellow",
        material: "21_shiny_2r",
    },
    "#daa800" : {
        display: "Pastel Sarı",
        name: "#208 Post office yellow",
        material: "21_shiny_2r",
    },
    "#ffc100" : {
        display: "Kargo Sarı",
        name: "#256 Cargo yellow",
        material: "21_shiny_2r",
    },
    "#ff6d00" : {
        display: "Marigold",
        name: "#351 Municipal orange",
        material: "21_shiny_2r",
    },
    "#e64f00" : {
        display: "Daggi ",
        name: "#363 Daggi orange",
        material: "21_shiny_2r",
    },
    "#ce1000" : {
        display: "Açık Kırmızı",
        name: "#032 Light red",
        material: "21_shiny_2r",
    },
    "#ca2a2d" : {
        display: "Gül",
        name: "#897 Rose-hip",
        material: "21_shiny_2r",
    },
    "#c00019" : {
        display: "Kardinal",
        name: "#028 Cardinal red",
        material: "21_shiny_2r",
    },
    "#b71713" : {
        display: "Auburn",
        name: "#031 Red",
        material: "21_shiny_2r",
    },
    "#b0040e" : {
        display: "Geranyum",
        name: "#305 Geranium red",
        material: "21_shiny_2r",
    },
    "#b80d27" : {
        display: "Maroon",
        name: "#882 Cargo red",
        material: "21_shiny_2r",
    },
    "#a3000d" : {
        display: "Chili",
        name: "#371 Chili red",
        material: "21_shiny_2r",
    },
    "#89071c" : {
        display: "Rust",
        name: "#030 Dark red",
        material: "21_shiny_2r",
    },
    "#570d1e" : {
        display: "Tyrian",
        name: "#026 Purple red",
        material: "21_shiny_2r",
    },
    "#ec7bb4" : {
        display: "Koral",
        name: "#045 Soft pink",
        material: "21_shiny_2r",
    },
    "#c22e70" : {
        display: "Magenta",
        name: "#077 Telemagenta",
        material: "21_shiny_2r",
    },
    "#38a0d4" : {
        display: "Buz Mavi",
        name: "#056 Ice blue",
        material: "21_shiny_2r",
    },
    "#4978c0" : {
        display: "Glacier",
        name: "#555 Glacier blue",
        material: "21_shiny_2r",
    },
    "#0075b9" : {
        display: "Fyord",
        name: "#547 Fjord blue",
        material: "21_shiny_2r",
    },
    "#00489a" : {
        display: "Deniz",
        name: "#509 Sea blue",
        material: "21_shiny_2r",
    },
    "#004a8a" : {
        display: "Kobalt",
        name: "#572 Police blue",
        material: "21_shiny_2r",
    },
    "#004594" : {
        display: "Oxford",
        name: "#057 Traffic blue",
        material: "21_shiny_2r",
    },
    "#003d7e" : {
        display: "Saf Mavi",
        name: "#067 Blue",
        material: "21_shiny_2r",
    },
    "#142d7a" : {
        display: "Payne",
        name: "#049 King blue",
        material: "21_shiny_2r",
    },
    "#082c73" : {
        display: "Geceyarısı",
        name: "#511 Night blue",
        material: "21_shiny_2r",
    },
    "#004a7b" : {
        display: "Indigo",
        name: "#544 Indigo blue",
        material: "21_shiny_2r",
    },
    "#02234a" : {
        display: "Serin Buz",
        name: "#564 Light navy",
        material: "21_shiny_2r",
    },
    "#101234" : {
        display: "Baltik",
        name: "#178 Baltic Blue",
        material: "21_shiny_2r",
    },
    "#71bd00" : {
        display: "Lime",
        name: "#464 Lawn green",
        material: "21_shiny_2r",
    },
    "#94a122" : {
        display: "Brass",
        name: "#688 Algae green",
        material: "21_shiny_2r",
    },
    "#00a621" : {
        display: "Sonbahar",
        name: "#602 Grass green",
        material: "21_shiny_2r",
    },
    "#439f3d" : {
        display: "Meşe",
        name: "#486 Tree green",
        material: "21_shiny_2r",
    },
    "#006e3a" : {
        display: "Avcı Yeşil",
        name: "#612 Police green",
        material: "21_shiny_2r",
    },
    "#003f3e" : {
        display: "Juniper",
        name: "#689 Juniper",
        material: "21_shiny_2r",
    },
    "#013929" : {
        display: "Bistre",
        name: "#622 Fir tree green",
        material: "21_shiny_2r",
    },
    "#273222" : {
        display: "Onyx",
        name: "#286 Bottle green",
        material: "21_shiny_2r",
    },
    "#00799c" : {
        display: "Lagoon",
        name: "#553 Lagoon",
        material: "21_shiny_2r",
    },
    "#c2c2c2" : {
        display: "Duman",
        name: "#711 Stone grey",
        material: "21_shiny_2r",
    },
    "#acaead" : {
        display: "Kaya Gri",
        name: "#730 Simple grey",
        material: "21_shiny_2r",
    },
    "#a3a4a1" : {
        display: "Slate",
        name: "#724 Ice grey",
        material: "21_shiny_2r",
    },
    "#828989" : {
        display: "Zırh Gri",
        name: "#076 Telegrey",
        material: "21_shiny_2r",
    },
    "#454748" : {
        display: "Eigen",
        name: "#073 Dark grey",
        material: "21_shiny_2r",
    },
    "#0c0b0c" : {
        display: "Zeytin",
        name: "#070 Black",
        material: "21_shiny_2r",
    },
}

export const palette_oracle_970_metallic = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Kaplama Yok",
        material: "01_default",
    },
    "#d4cfc7" : {
        display: "Nacre",
        name: "#946 Nacre",
        material: "02_shiny",
    },
    "#74797d" : {
        display: "Gümüş ",
        name: "#904 Silver lake",
        material: "02_shiny",
    },
    "#7d8184" : {
        display: "İnci",
        name: "#090 Silver grey",
        material: "02_shiny",
    },
    "#5f5f60" : {
        display: "Alüminyum",
        name: "#908 Aluminium",
        material: "02_shiny",
    },
    "#696c6c" : {
        display: "Tin",
        name: "#933 Tin metallic",
        material: "02_shiny",
    },
    "#5a5b52" : {
        display: "Zinc",
        name: "#934 Zinc metallic",
        material: "02_shiny",
    },
    "#4e5151" : {
        display: "Çelik",
        name: "#935 Grey cast iron",
        material: "02_shiny",
    },
    "#45484b" : {
        display: "Grafit",
        name: "#932 Graphite metallic",
        material: "02_shiny",
    },
    "#2f3237" : {
        display: "Karakalem",
        name: "#937 Charcoal metallic",
        material: "02_shiny",
    },
    "#38383b" : {
        display: "Antrasit",
        name: "#093 Anthracite",
        material: "02_shiny",
    },
    "#1e1f20" : {
        display: "Gölge",
        name: "#704 Black metallic",
        material: "02_shiny",
    },
    "#918164" : {
        display: "Brass",
        name: "#922 Brass",
        material: "02_shiny",
    },
    "#91794e" : {
        display: "Pyrite",
        name: "#926 Pyrite",
        material: "02_shiny",
    },
    "#9e8750" : {
        display: "Altın",
        name: "#091 Gold",
        material: "02_shiny",
    },
    "#885d2b" : {
        display: "Bronz",
        name: "#920 Bronze",
        material: "02_shiny",
    },
    "#674d38" : {
        display: "Antik",
        name: "#921 Bronze antique",
        material: "02_shiny",
    },
    "#312618" : {
        display: "Orient",
        name: "#874 Orient brown metallic",
        material: "02_shiny",
    },
    "#5d1518" : {
        display: "Kızılağaç",
        name: "#369 Red brown metallic",
        material: "02_shiny",
    },
    "#3b2751" : {
        display: "Mauve",
        name: "#406 Violet metallic",
        material: "02_shiny",
    },
    "#506b81" : {
        display: "Dove",
        name: "#195 Dove blue metallic",
        material: "02_shiny",
    },
    "#003d71" : {
        display: "Azur",
        name: "#197 Azur metallic",
        material: "02_shiny",
    },
    "#002d64" : {
        display: "Royal",
        name: "#196 Night blue metallic",
        material: "02_shiny",
    },
    "#131e40" : {
        display: "Uzay",
        name: "#192 Deep blue metallic",
        material: "02_shiny",
    },
    "#253d35" : {
        display: "Fern",
        name: "#677 Fir tree green metallic",
        material: "02_shiny",
    },
}

export const palette_oracle_970_matte = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Kaplama Yok",
        material: "01_default",
    },
    "#f0f1f1" : {
        display: "Abalone",
        name: "#010 White matt",
        material: "05_porcelain",
    },
    "#ffa725" : {
        display: "Safran",
        name: "#223 Safron yellow matt",
        material: "05_porcelain",
    },
    "#3b4231" : {
        display: "Nato",
        name: "#285 Nato olive",
        material: "05_porcelain",
    },
    "#1c1c1c" : {
        display: "Mat Siyah",
        name: "#070 Black matt",
        material: "05_porcelain",
    },
    "#57ceb7" : {
        display: "Mint",
        name: "#055 Mint",
        material: "05_porcelain",
    },
    "#323233" : {
        display: "Süper Mat",
        name: "#070 Black super matt",
        material: "05_porcelain",
    },
}

export const palette_oracle_970_metallic_matte = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Kaplama Yok",
        material: "01_default",
    },
    "#8b8e91" : {
        display: "Rhino",
        name: "#090 Silver grey",
        material: "02_shiny",
    },
    "#535557" : {
        display: "Iron",
        name: "#932 Graphite metallic",
        material: "02_shiny",
    },
    "#3e4146" : {
        display: "Anchor",
        name: "#937 Charcoal metallic",
        material: "02_shiny",
    },
    "#3f3f42" : {
        display: "Shadow",
        name: "#093 Anthracite metallic",
        material: "02_shiny",
    },
    "#a58e52" : {
        display: "Amber",
        name: "#091 Gold",
        material: "02_shiny",
    },
    "#987f53" : {
        display: "Dijon",
        name: "#926 Pyrite",
        material: "02_shiny",
    },
    "#9b5838" : {
        display: "Brick",
        name: "#944 Red gold L metallic",
        material: "02_shiny",
    },
    "#885629" : {
        display: "Copper",
        name: "#092 Copper",
        material: "02_shiny",
    },
    "#8d673b" : {
        display: "Ochre",
        name: "#920 Bronze",
        material: "02_shiny",
    },
    "#a10521" : {
        display: "Imperial",
        name: "#372 Imperial Red Pearl",
        material: "02_shiny",
    },
    "#8f0424" : {
        display: "Burgunov",
        name: "#368 Dark red metallic",
        material: "02_shiny",
    },
    "#612023" : {
        display: "Carmine",
        name: "#369 Red brown metallic",
        material: "02_shiny",
    },
    "#402e56" : {
        display: "Grape",
        name: "#406 Violet metallic",
        material: "02_shiny",
    },
    "#004a7e" : {
        display: "Carolina",
        name: "#197 Azure metallic",
        material: "02_shiny",
    },
    "#143468" : {
        display: "Nightblue",
        name: "#196 Night blue metallic",
        material: "02_shiny",
    },
    "#21232e" : {
        display: "Moonlight",
        name: "#190 Moonlight metallic",
        material: "02_shiny",
    },
}